import React, { useEffect, useState } from 'react';

import AddLeagueModal from '../league/AddLeagueModal';

// Tab components
import ProfileTab from '../profile/ProfileTab';
import NotificationTab from '../profile/NotificationTab';
import PrivacyTab from '../profile/PrivacyTab';
import CommunicationTab from '../profile/CommunicationTab';
import MessagingTab from '../profile/MessagingTab';
import CloseAccountTab from '../profile/CloseAccountTab';

function Settings({ activeTab }) {

    return (
        <>
            <div className={`tab-pane fade ${activeTab === 'nav-setting-tab-1' ? 'show active' : ''}`} id="nav-setting-tab-1">
                {activeTab === 'nav-setting-tab-1' && <ProfileTab />}
            </div>
            <div className={`tab-pane fade ${activeTab === 'nav-setting-tab-2' ? 'show active' : ''}`} id="nav-setting-tab-2">
                {activeTab === 'nav-setting-tab-2' && <NotificationTab />}
            </div>
            <div className={`tab-pane fade ${activeTab === 'nav-setting-tab-3' ? 'show active' : ''}`} id="nav-setting-tab-3">
                {activeTab === 'nav-setting-tab-3' && <PrivacyTab />}
            </div>
            <div className={`tab-pane fade ${activeTab === 'nav-setting-tab-4' ? 'show active' : ''}`} id="nav-setting-tab-4">
                {activeTab === 'nav-setting-tab-4' && <CommunicationTab />}
            </div>
            <div className={`tab-pane fade ${activeTab === 'nav-setting-tab-5' ? 'show active' : ''}`} id="nav-setting-tab-5">
                {activeTab === 'nav-setting-tab-5' && <MessagingTab />}
            </div>
            <div className={`tab-pane fade ${activeTab === 'nav-setting-tab-7' ? 'show active' : ''}`} id="nav-setting-tab-7">
                {activeTab === 'nav-setting-tab-7' && <CloseAccountTab />}
            </div>
        </>
    );
}

export default Settings;
